import { type OutreachUrgencyFilter } from '@apps/web/components/admin/outreach_observability/constants';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@apps/web/components/ui/select';

const OUTREACH_URGENCY_OPTIONS: ReadonlyArray<{
    readonly value: OutreachUrgencyFilter;
    readonly label: string;
}> = [
    { value: 'all', label: 'All outreaches' },
    { value: 'normal', label: 'Normal' },
    { value: 'urgent', label: 'Urgent' },
    { value: 'swarm', label: 'Swarm' },
];

type OutreachUrgencySelectProps = {
    readonly value: OutreachUrgencyFilter;
    readonly onValueChange: (value: OutreachUrgencyFilter) => void;
    readonly ariaLabel?: string;
};

export function OutreachUrgencySelect({
    value,
    onValueChange,
    ariaLabel = 'Outreach urgency',
}: OutreachUrgencySelectProps) {
    return (
        <Select
            value={value}
            onValueChange={(next) => {
                onValueChange(next as OutreachUrgencyFilter);
            }}
        >
            <SelectTrigger size="sm" className="w-40" aria-label={ariaLabel}>
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                {OUTREACH_URGENCY_OPTIONS.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                        {option.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
